var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component && _vm.artist)?_c(_vm.component,{tag:"component",attrs:{"artist":_vm.artist,"running":_vm.artistRunning},on:{"play":_vm.play,"pause":_vm.pause,"like":_vm.likeArtist,"unlike":_vm.unlikeArtist}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }